<template>
  <div
    v-if="tutor"
    class="tutor"
  >
    <div class="v2-container-small">
      <h2 class="tutor__title">
        курс ведет
      </h2>

      <div class="tutor__content">
        <div class="tutor__image">
          <img
            :src="tutor.image"
            alt="tutor"
          >
        </div>

        <div class="tutor__card">
          <div class="tutor__card--wrap">
            <h6>
              Мой опыт наглядно:
            </h6>

            <ul>
              <li
                v-for="(item, idx) of tutor.skills"
                :key="idx"
              >
                <img
                  src="/v2/ege/tutors/dot.svg"
                  alt="dot"
                >
                <span v-html="item" />
              </li>
            </ul>
          </div>

          <button @click="$emit('openModal', tutor.subject)">
            Записаться на бесплатный урок
          </button>
        </div>

        <button
          class="tutor__button"
          @click="$emit('openModal', tutor.subject)"
        >
          Записаться на бесплатный урок
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { EGE_TUTORS, OGE_TUTORS } from './tutors';

export default {
  name: 'CourseTutor',

  computed: {
    tutor() {
      const pageName = this.$route?.params?.subpage;

      if (this.$route.name === 'ege-subpage') {
        return EGE_TUTORS[pageName] || null;
      }
      if (this.$route.name === 'oge-subpage') {
        return OGE_TUTORS[pageName] || null;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.tutor {
  &__title {
    font-size: 45px;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: -0.03em;
    color: $black-color;
    text-transform: uppercase;

    @include media-down(tablet) {
      font-size: 26px;
      line-height: 29px;
      letter-spacing: -0.02em;
    }
  }

  &__content {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;

    @include media-down(laptop) {
      flex-wrap: wrap;
      gap: 20px;
    }

    @include media-down(tablet) {
      margin-top: 32px;
      gap: 12px;
    }
  }

  &__image {
    width: calc(65.32% - 10px);

    @media (max-width: 1200px) {
      width: calc(60% - 10px);
    }

    @include media-down(laptop) {
      width: 100%;
    }

    img {
      width: 100%;

      border-radius: 20px;
      box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);

      @include media-down(laptop) {
        display: block;
        max-width: 769px;
        margin: 0 auto;
      }
    }
  }

  &__card {
    width: calc(34.68% - 10px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 25px 30px;

    background-color: $white-color;
    border-radius: 20px;
    box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);

    @media (max-width: 1200px) {
      width: calc(40% - 10px);
    }

    @include media-down(laptop) {
      width: 100%;
      max-width: 769px;
      margin: 0 auto;
    }

    @include media-down(tablet) {
      padding: 16px 8px;
    }

    h6 {
      font-size: 24px;
      font-weight: 500;
      line-height: 31px;
      color: $black-color;

      @include media-down(tablet) {
        font-size: 18px;
        line-height: 22px;
      }
    }

    ul {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      @include media-down(tablet) {
        margin-top: 12px;
        gap: 8px;
      }

      li {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        font-size: 16px;
        font-weight: 500;
        line-height: 130%;
        letter-spacing: -0.01em;
        color: $black-color;

        @include media-down(tablet) {
          font-size: 14px;
        }

        img {
          margin-right: 8px;
          margin-top: 4px;
        }
      }
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;

      border: none;
      border-radius: 50px;
      background-color: #FA5019;

      font-family: 'TildaSans', sans-serif;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      color: $white-color;

      transition: background-color .2s ease-out;
      cursor: pointer;

      &:hover {
        background-color: darken(#FA5019, 5%);
      }

      @include media-down(laptop) {
        margin-top: 20px;
      }

      @include media-down(tablet) {
        display: none ;
      }
    }
  }

  &__button {
    display: none;

    @include media-down(tablet) {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 48px;

      border: none;
      border-radius: 50px;
      background-color: #FA5019;

      font-family: 'TildaSans', sans-serif;
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
      color: $white-color;

      transition: background-color .2s ease-out;
      cursor: pointer;

      &:hover {
        background-color: darken(#FA5019, 5%);
      }
    }
  }
}
</style>
